import React, { useEffect, useState } from 'react'
import { Box, Button, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import CrossingMasterTable from './CrossingMasterTable'
import CrossingMasterBulkUpdate from './CrossingMasterBulkUpdate'

const GSCrossingMasterPage = () => { const [senderSect] = useState(['UPDATE CROSSING MASTER', 'CROSSING MASTER BULK UPDATE'])
    const [senderSectContent, setSenderSectContent] = useState(0)

    const handleSenderSect = (event, newValue) => {
        setSenderSectContent(newValue)
    }
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }

    return (
        <>
            <Item
                sx={{
                    width: '100%',
                    margintTop: '10px',
                    padding: '0px',
                    //   paddingLeft: '19px',
                    //  marginRight: '25px',
                }}
            >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={senderSectContent} onChange={handleSenderSect} aria-label="bsic tabs example">
                        {senderSect.map((reqType, index) => (
                            <Tab key={`sender_${index}`} label={reqType} {...a11yProps(index)} style={{ lineHeight: '2.5' }} />
                        ))}
                    </Tabs>
                </Box>
            </Item>
            {senderSectContent === 0 ? <CrossingMasterTable /> : ''}
            {senderSectContent === 1 ? <CrossingMasterBulkUpdate /> : ''}
        </>
    )
}

export default GSCrossingMasterPage
